import React from "react";
import styled from "styled-components";
import { TextLabel, TextPlaceholder } from "..";
import { colors } from "common/const/colors";

const Legend = ({ data, direction = "row" }) => {
  const hasRate = data.some((item) => item?.rate);

  return (
    <LegendContainer style={{ flexDirection: direction }}>
      {data.map((item, index) => (
        <div
          style={{ display: "flex", flexDirection: "column", gap: "0.5rem" }}>
          <LegendItem key={index}>
            <LegendColor $fillcolor={item.color} />
            <TextPlaceholder>
              {hasRate ? item.title : `${item.title}`}
            </TextPlaceholder>
          </LegendItem>
          {hasRate && (
            <TextLabel>
              {`${item.value} `}
              <span style={{ color: colors.LightNavy }}>
                ({item.rate.toFixed(2) ?? "-"}%)
              </span>
            </TextLabel>
          )}
        </div>
      ))}
    </LegendContainer>
  );
};

const LegendContainer = styled.div`
  display: flex;
  justify-content: center;
  gap: 1rem;
`;

const LegendItem = styled.div`
  display: flex;
  align-items: center;
  margin-right: 20px;
  gap: 0 0.5rem;
`;

const LegendColor = styled.div`
  width: 1rem;
  height: 1rem;
  background-color: ${(props) => props.$fillcolor};
  border: ${(props) =>
    props.$fillcolor === "var(--White)"
      ? "var(--border-width) solid var(--Gray)"
      : "none"};
  border-radius: 2px;
`;

export { Legend };
